import { ReactComponent as KalamaLockup } from 'src/assets/images/kalama-lockup-horizontal.svg'
import { KALAMA_HELP_ARTICLE_URL } from 'src/modules/brand/utils/kalama-notice'
import { FormattedText, Modal } from 'src/modules/core/components'
import type { KalamaTeaserModalProps } from './kalama-teaser-modal.interface'
import classes from './kalama-teaser-modal.module.scss'

export function KalamaTeaserModal({ open, onClose }: KalamaTeaserModalProps) {
  if (!open) {
    return null
  }

  return (
    <Modal variant="primary" closeOnBackdropClick={false} onClose={onClose}>
      <div className={classes.root} data-testid="kalama-teaser-modal">
        <KalamaLockup className={classes.lockup} title="Kalama" />
        <p className={classes.message}>
          <FormattedText id="brand.kalamaTeaser.message" />
        </p>
        <a className={classes.link} href={KALAMA_HELP_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
          <FormattedText id="brand.kalamaTeaser.link" />
        </a>
      </div>
    </Modal>
  )
}
